module.exports = __webpack_public_path__ + "img/flicky-christmas-1.05b8fd66.png";